<template>
  <div class="insured-address-form-container">
    <Panel title="2. ข้อมูลของผู้ขอเอาประกันภัย">
      <div class="insured-information-section clearfix">
        <div class="col-sm-6 insured-information">
          <span class="information-title">ชื่อผู้ขอเอาประกัน</span>
          <span class="information-text">{{
            `${insuredInformation.namePrefix} ${insuredInformation.firstname} ${insuredInformation.lastname}`
          }}</span>
        </div>
        <div class="col-sm-6 insured-information">
          <span class="information-title">{{
            insuredInformation.idType === 1 ? 'เลขบัตรประจำตัวประชาชน' : 'เลขที่หนังสือเดินทาง'
          }}</span>
          <span class="information-text">{{ insuredInformation.idNumber }}</span>
        </div>
        <div class="col-sm-6 insured-information">
          <span class="information-title">อาชีพ</span>
          <span class="information-text">{{ insuredInformation.occupation }}</span>
        </div>
        <div class="col-sm-6 insured-information">
          <span class="information-title">วัน เดือน ปีเกิด (พ.ศ.)</span>
          <span class="information-text">{{ insuredInformation.dob }}</span>
        </div>
        <div class="col-sm-6 insured-information">
          <span class="information-title">อายุ</span>
          <span class="information-text">{{ `${insuredInformation.age} ปี` }}</span>
        </div>
        <div class="col-sm-6 insured-information">
          <span class="information-title">เพศ</span>
          <span class="information-text">{{
            insuredInformation.gender === 'M' ? 'ชาย' : 'หญิง'
          }}</span>
        </div>
        <div class="col-sm-6 insured-information">
          <span class="information-title">อีเมล</span>
          <span class="information-text">{{ insuredInformation.email }}</span>
        </div>
        <div class="col-sm-3 insured-information">
          <span class="information-title">ส่วนสูง</span>
          <span class="information-text">{{ `${insuredInformation.height} ซ.ม.` }}</span>
        </div>
        <div class="col-sm-3 insured-information">
          <span class="information-title">น้ำหนัก</span>
          <span class="information-text">{{ `${insuredInformation.weight} กก.` }}</span>
        </div>
      </div>
      <div class="current-address-form-container">
        <div class="title">ที่อยู่ตามทะเบียนบ้าน</div>
        <Address
          :data="currentAddress"
          :validation="generateValidationErrors('currentAddress')"
          disabled
        />
      </div>
      <div class="policy-send-method-container">
        <div class="title">วิธีจัดส่งกรมธรรม์ฉบับจริง</div>
        <div class="method-radio-container">
          <Radio
            name="policySendMethod"
            label="postal"
            v-model="policySendMethod"
            :disabled="isDisabledForm"
          >
            จัดส่งเอกสารตามที่อยู่ที่ระบุ (สำเนาหน้าตารางกรมธรรม์และสำเนาใบเสร็จส่งให้โดยอีเมล)
          </Radio>
        </div>
        <div class="method-radio-container" v-if="insuredInformation.email">
          <Radio
            name="policySendMethod"
            label="email"
            v-model="policySendMethod"
            :disabled="isDisabledForm"
          >
            จัดส่งกรมธรรม์อิเล็กทรอนิกส์โดยอีเมล
          </Radio>
        </div>
        <div class="error-delivery-method" v-if="validationErrors.has('deliveryMethod')">
          * กรุณาเลือกวิธีจัดส่งกรมธรรม์
        </div>
      </div>
      <div class="email-form-container" v-show-slide="policySendMethod === 'email'">
        <div class="form-group col-sm-7">
          <div class="input-group">
            <span class="input-group-addon nobd-nobg">อีเมล</span>
            <input
              type="text"
              class="form-control input-sm"
              v-model="insuredInformation.email"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="policy-send-address-container" v-show-slide="policySendMethod === 'postal'">
        <div class="same-address-checkbox-section">
          <Checkbox
            :isCheck="isSameAddress"
            :onCheck="onCheckSameAddress"
            optionText="เหมือนที่อยู่ตามทะเบียนบ้าน"
            :disabled="isDisabledForm"
          />
        </div>
        <Address
          :data="deliveryAddress"
          :isSameAddress="isSameAddress"
          :validation="generateValidationErrors('deliveryAddress')"
          :disabled="isSameAddress || isDisabledForm"
          v-show-slide="!isSameAddress"
        />
      </div>

      <div class="hospital-section" v-if="_.size(hospitalsList)">
        <div class="title-text">
          <i class="fa fa-heartbeat" />
          รายชื่อโรงพยาบาลใกล้เคียง
        </div>
        <div class="hospital-btn-container">
          <Button class="hospital-btn" type="info" @click.native="isShowHospitalModal = true">
            <i class="fa fa-book" /> โรงพยาบาล
          </Button>
        </div>
      </div>
    </Panel>

    <Modal modalClass="hospitals-list-container" v-if="isShowHospitalModal">
      <div class="hospitals-list-header-section">
        <i class="fa fa-heartbeat" />
        รายชื่อโรงพยาบาลใกล้เคียง
      </div>
      <div class="hospitals-list-content-section">
        <p
          class="hospital-item"
          v-for="hospital in hospitalsList"
          :key="hospital.id"
          v-text="hospital.name"
        />
      </div>
      <div class="hospitals-list-bottom-section">
        <div class="close-btn-container">
          <Button
            class="close-btn"
            theme="outline"
            type="info"
            @click.native="isShowHospitalModal = false"
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import { Validator } from 'vee-validate'

import Address from '@/components/List/Address'
import Button from '@/components/Button'
import Checkbox from '@/components/Checkbox'
import Modal from '@/components/Modal'
import Panel from '@/components/Panel'
import Radio from '@/components/Radio'
import { generateAuthorizationRequestHeader } from '@/lib/services'
import API from '@/lib/api'
import Vue from 'vue'

const { mapFields: mapApplicationFields } = createHelpers({
  getterType: 'getApplicationFields',
  mutationType: 'updateApplicationFields',
})

export default {
  name: 'InsuredAddressForm',
  data: () => ({
    isShowHospitalModal: false,
  }),
  watch: {
    'currentAddress.subdistrict'(subdistrictId) {
      if (subdistrictId) {
        this.getHospitalsInformation(subdistrictId)
      }
    },
    policySendMethod(method) {
      if (method === 'postal') {
        this.validationRules.deliveryAddress = 'required'
        this.validationRules.deliverySubdistrict = 'required'
        this.validationRules.deliveryDistrict = 'required'
        this.validationRules.deliveryProvince = 'required'
        this.validationRules.deliveryCountry = 'required'
        this.validationRules.deliveryPostalCode = 'required'
        this.validationRules.deliveryMobilePhone = 'required|length:10'
      } else {
        this.validationRules.deliveryAddress = ''
        this.validationRules.deliverySubdistrict = ''
        this.validationRules.deliveryDistrict = ''
        this.validationRules.deliveryProvince = ''
        this.validationRules.deliveryCountry = ''
        this.validationRules.deliveryPostalCode = ''
        this.validationRules.deliveryMobilePhone = ''
      }
    },
  },
  computed: {
    ...mapApplicationFields({
      insuredInformation: 'data.insuredAddress.insuredInformation',
      isSameAddress: 'data.insuredAddress.isSameAddress',
      policySendMethod: 'data.insuredAddress.policySendMethod',
      currentAddress: 'data.insuredAddress.currentAddress',
      deliveryAddress: 'data.insuredAddress.deliveryAddress',
      validationRules: 'validation.rules',
    }),
    ...mapGetters({
      validationErrors: 'applicationValidationErrors',
      isDisabledForm: 'isDisabledApplicationForm',
      hospitalsList: 'hospitalsList',
    }),
    generateValidationErrors() {
      return (type) => {
        if (type === 'currentAddress') {
          return {
            address: this.validationErrors.has('currentAddress'),
            subdistrict: this.validationErrors.has('currentSubdistrict'),
            district: this.validationErrors.has('currentDistrict'),
            province: this.validationErrors.has('currentProvince'),
            country: this.validationErrors.has('currentCountry'),
            postalCode: this.validationErrors.has('currentPostalCode'),
            mobilePhone: this.validationErrors.has('currentMobilePhone'),
          }
        }

        return {
          address: this.validationErrors.has('deliveryAddress'),
          subdistrict: this.validationErrors.has('deliverySubdistrict'),
          district: this.validationErrors.has('deliveryDistrict'),
          province: this.validationErrors.has('deliveryProvince'),
          country: this.validationErrors.has('deliveryCountry'),
          postalCode: this.validationErrors.has('deliveryPostalCode'),
          mobilePhone: this.validationErrors.has('deliveryMobilePhone'),
        }
      }
    },
  },
  components: {
    Address,
    Button,
    Checkbox,
    Modal,
    Panel,
    Radio,
  },
  methods: {
    ...mapActions(['getHospitalsInformation']),
    onCheckSameAddress($evt) {
      this.isSameAddress = $evt.target.checked

      if ($evt.target.checked) {
        this.deliveryAddress = { ...this.currentAddress }
      } else {
        this.deliveryAddress = {
          address: '',
          subdistrict: '',
          district: '',
          province: '',
          country: 'ประเทศไทย',
          postalCode: '',
          homePhone: '',
          mobilePhone: '',
        }
      }
    },
  },
}
</script>

<style lang="scss">
.insured-address-form-container {
  .existing-generali-checkbox-section {
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 24px;
  }

  .insured-information-section {
    border-bottom: 1px dashed #cccccc;
    margin-bottom: 24px;
    padding-bottom: 24px;

    .insured-information {
      margin-bottom: 16px;

      .information-title {
        margin-right: 8px;
      }

      .information-text {
        color: #00a350;
      }
    }
  }

  .current-address-form-container {
    border-bottom: 1px dashed #ccc;
    margin-bottom: 24px;
    padding-bottom: 24px;

    .title {
      font-family: 'psl_kanda_extraregular' !important;
      margin-bottom: 8px;
    }
  }

  .policy-send-method-container {
    margin-bottom: 24px;

    .title {
      display: inline-block;
      font-family: 'psl_kanda_extraregular' !important;
      margin-right: 40px;
    }

    .method-radio-container {
      display: inline-block;
      margin-right: 40px;
    }

    .error-delivery-method {
      color: #e40000;
      display: inline-block;
      font-size: 12px;
      line-height: 16px;
    }
  }

  .policy-send-address-container {
    .same-address-checkbox-section {
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 16px;
    }
  }

  .hospital-section {
    display: flex;
    align-items: center;

    .title-text {
      margin-right: 24px;
    }
  }
}

.hospitals-list-container {
  .modal-container {
    padding: 40px;
    width: 80%;
  }

  .hospitals-list-header-section {
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 24px;
  }

  .hospitals-list-content-section {
    margin-bottom: 24px;

    .hospital-item::before {
      content: '- ';
    }
  }

  .hospitals-list-bottom-section {
    .close-btn-container {
      text-align: right;
    }
  }
}
</style>
